import { useCallback, useContext, useMemo } from 'react';
import { GroupFeaturesContext } from '@trinity/chat-components/containers/Chat';
import { useCookie } from '@trinity/chat-components/hooks/useCookie';
import { GetStartedContext } from './context';

type Props = {
  children: React.ReactNode;
};

const cookieName = 'msl-copilot:get-started-dismissed';
const dismissedCookieValue = 'dismissed';

export const GetStartedContainer = (props: Props) => {
  const features = useContext(GroupFeaturesContext);
  const getStartedEnabled = features.workspaces;

  const [cookieValue, setCookie] = useCookie(cookieName);

  const visible = useMemo(() => {
    return false; // Force hide Get Started for now --- IGNORE ---
    // return cookieValue !== dismissedCookieValue && getStartedEnabled;
  }, [cookieValue, getStartedEnabled]);

  const toggleVisibility = useCallback(() => {
    setCookie({
      expires: new Date('2100-01-01'),
      value: dismissedCookieValue,
    });
  }, [setCookie]);

  return (
    <GetStartedContext.Provider value={[visible, toggleVisibility]}>
      {props.children}
    </GetStartedContext.Provider>
  );
};
